import { render, staticRenderFns } from "./MedicineDetail.vue?vue&type=template&id=2d4c851e"
import script from "./MedicineDetail.vue?vue&type=script&lang=js"
export * from "./MedicineDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports